/* eslint-disable react-hooks/exhaustive-deps */

import FilterBoxTop from './FilterBoxTop'
import FilterCategory from './FilterCategory'

type Props = {
  searchWord: any
  setSearchWord: any
  filter: any
  setFilter: any
  isFavorites: any
  setIsFavorites: any
  selectedSort: any
  setSelectedSort: any
  sortOptions: any
  isAsc: any
  setIsAsc: any
  selectedGroup: any
  setSelectedGroup: any
}

const FilterBox = (props: Props) => {
  const {
    searchWord,
    setSearchWord,
    filter,
    setFilter,
    isFavorites,
    setIsFavorites,
    selectedSort,
    setSelectedSort,
    sortOptions,
    isAsc,
    setIsAsc,
    selectedGroup,
    setSelectedGroup,
  } = props

  return (
    <>
      <div className="filter-box stack-small">
        <FilterBoxTop
          searchWord={searchWord}
          setSearchWord={setSearchWord}
          selectedSort={selectedSort}
          setSelectedSort={setSelectedSort}
          options={sortOptions}
          isAsc={isAsc}
          setIsAsc={setIsAsc}
        />
        <FilterCategory filter={filter} setFilter={setFilter} selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup} isFavorites={isFavorites} setIsFavorites={setIsFavorites} />
        
      </div>
    </>
  )
}

export default FilterBox
